import React from "react";

const PeopleItem = ({ isActive, info, onClick, onRemoveClick }) => {
	return (
		<li className={isActive ? "active" : ""} style={{ position: "relative" }}>
			<button
				className="btn btn-link"
				onClick={onRemoveClick}
				style={{ position: "absolute", zIndex: 999, right: "0px" }}
			>
				<i className="fa fa-trash" />
			</button>
			<a className="clearfix" style={{ cursor: "pointer" }} onClick={onClick}>
				<table width="100%" style={{ border: "0" }}>
					<tbody>
						<tr>
							<td style={{ width: "55px" }}>
								<img
									src="https://bootdey.com/img/Content/user_3.jpg"
									alt=""
									className="img-circle"
									style={{ float: "left" }}
								/>
							</td>
							<td>
								<div className="friend-name">
									<strong>{info.penerima.user.user_nama}</strong>
									<br />
									<small className="text-secondary">
										{info.user.user_nama} : {info.conversation_text}
									</small>
									<br />
								</div>
								<div className="last-message text-muted">
									<small>{info.conversation_date}</small>
								</div>
								<div className="chat-alert" />
								{/* <small className="chat-alert label label-danger">New</small> */}
							</td>
						</tr>
					</tbody>
				</table>
			</a>
		</li>
	);
};

export default PeopleItem;



// WEBPACK FOOTER //
// ./src/views/Chat/components/PeopleItem.js